<template>
  <div class="dhsharePage">
    <div class="spAmation" v-if="!pageShow">
      <div :class="['textAmationed', kpShow ? 'animated rotateOut' : '']">
        <div class="logo">
          <img :src="baseUrl + 'img/dhShare/dhLogo.png'" />
        </div>
        <div class="circleBox">
          <div
            :class="[
              'countDown',
              this.iphonexType == true ? 'changeBottom' : '',
            ]"
            v-if="this.countDownShow"
          >
            <van-circle
              class="countAnimation"
              v-model="currentRate"
              :rate="rate"
              speed="18"
              size="65"
              stroke-width="150"
              layer-color="#ccefe3"
              color="#6bc3a5"
              :text="countDownText"
            />
          </div>
          <p class="kpBtn" v-if="!countDownShow" @click="actionPage">
            <img
              :src="baseUrl + 'img/dhShare/hpIcon.png'"
              class="hpAmationed"
            />
          </p>
        </div>
      </div>
    </div>
    <div :class="['sectionPage']" v-if="pageShow">
      <!-- <van-swipe
        @change="onChange"
        class="slideBox"
        :loop="false"
        :vertical="true"
        :show-indicators="false"
        :duration="1000"
      >
        <van-swipe-item
          v-for="(item, index) in slidePage"
          :key="index"
          class="slideItem"
          id="slideItem"
          :style="{
            height: pageHeight,
            width: pageWidth,
          }"
        >
          <div class="leftIcon" v-if="index > 0">
            <img :src="baseUrl + 'img/dhShare/leftIcon.png'" class="fl" />
            <img :src="baseUrl + 'img/dhShare/leftIcon.png'" class="fl" />
          </div>
          <one-page
            v-if="index == '0'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></one-page>
          <two-page
            v-if="index == '1'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></two-page>
          <three-page
            v-if="index == '2'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></three-page>
          <four-page
            v-if="index == '3'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></four-page>
          <five-page
            v-if="index == '4'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></five-page>
          <six-page
            v-if="index == '5'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></six-page>
          <seven-page
            v-if="index == '6'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></seven-page>
          <eight-page
            v-if="index == '7'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></eight-page>
          <div class="rightIcon clearfix" v-if="index < 7">
            <img :src="baseUrl + 'img/dhShare/rightIcon.png'" class="fl" />
            <img :src="baseUrl + 'img/dhShare/rightIcon.png'" class="fl" />
          </div>
        </van-swipe-item>
      </van-swipe> -->

      <swiper :options="swiperBoxOption" ref="mySwiper" class="slideBox">
        <swiper-slide
          v-for="(item, index) in slidePage"
          :key="index"
          class="slideItem"
          id="slideItem"
          :style="{
            height: pageHeight,
            width: pageWidth,
          }"
        >
          <div class="leftIcon" v-if="index > 0">
            <img :src="baseUrl + 'img/dhShare/leftIcon.png'" class="fl" />
            <img :src="baseUrl + 'img/dhShare/leftIcon.png'" class="fl" />
          </div>
          <one-page
            v-if="index == '0'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></one-page>
          <two-page
            v-if="index == '1'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></two-page>
          <three-page
            v-if="index == '2'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></three-page>
          <four-page
            v-if="index == '3'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></four-page>
          <five-page
            v-if="index == '4'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></five-page>
          <six-page
            v-if="index == '5'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></six-page>
          <seven-page
            v-if="index == '6'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></seven-page>
          <eight-page
            v-if="index == '7'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></eight-page>
          <nine-page
            v-if="index == '8'"
            :landscapeType="landscape"
            :newIndex="currentIndex"
          ></nine-page>
          <div class="rightIcon clearfix" v-if="index < 8">
            <img :src="baseUrl + 'img/dhShare/rightIcon.png'" class="fl" />
            <img :src="baseUrl + 'img/dhShare/rightIcon.png'" class="fl" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <van-overlay :show="landscape">
      <div class="wapPopup" @click.stop>
        <div class="wapMain">
          <img :src="baseUrl + 'img/dhShare/zhuan.png'" class="zhuan" />
          <p>请旋转手机后，锁屏重新进入</p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
/*eslint-disable*/
import wx from "weixin-js-sdk";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { isIphonex, is_wei } from "@/common/getDeviceType/getDeviceType";
import { mapState, mapMutations } from "vuex";
import "@/assets/style/animate.min.less";
const onePage = () => import("@/views/wechat/dhShare/components/onePage");
const twoPage = () => import("@/views/wechat/dhShare/components/twoPage");
const threePage = () => import("@/views/wechat/dhShare/components/threePage");
const fourPage = () => import("@/views/wechat/dhShare/components/fourPage");
const fivePage = () => import("@/views/wechat/dhShare/components/fivePage");
const sixPage = () => import("@/views/wechat/dhShare/components/sixPage");
const sevenPage = () => import("@/views/wechat/dhShare/components/sevenPage");
const eightPage = () => import("@/views/wechat/dhShare/components/eightPage");
const ninePage = () => import("@/views/wechat/dhShare/components/ninePage");
export default {
  name: "dhsharePage",
  components: {
    onePage,
    twoPage,
    threePage,
    fourPage,
    fivePage,
    sixPage,
    sevenPage,
    eightPage,
    ninePage,
    swiper,
    swiperSlide,
  },

  data() {
    return {
      userToken: "",
      baseUrl: process.env.BASE_URL,
      slidePage: [
        { slidePage: "1" },
        { slidePage: "2" },
        { slidePage: "3" },
        { slidePage: "4" },
        { slidePage: "5" },
        { slidePage: "6" },
        { slidePage: "7" },
        { slidePage: "8" },
        { slidePage: "9" },
      ],
      swiperBoxOption: {
        loop: false,
        speed: 2000,
        // effect: "fade",
        direction: "vertical", //设置水平horizontal还是垂直vertical
      },
      pageWidth: "",
      pageHeight: "",
      update: true,
      landscape: false,
      currentIndex: "0",
      pageShow: false,
      kpShow: false,
      iphonexType: "",
      countDownShow: true,
      currentRate: 0, //当前进度
      rate: 100, //目标进度

      countDownTime: 0,
      countDownText: this.countDownTime ? this.countDownTime : "" + "0%",
      is_weixn: is_wei(), //是否为微信
    };
  },

  mounted() {
    if (is_wei()) {
      this.getShare();
    }
    this.userToken = this.$route.query.token || "";
    let scollW =
      document.documentElement.clientWidth || document.body.clientWidth; //视口大小
    let scollH =
      document.documentElement.clientHeight || document.body.offsetHeight; //视口大小
    if (scollW > scollH) {
      this.pageWidth = scollH + "px";
      this.pageHeight = scollW + "px";
    } else {
      this.pageWidth = scollW + "px";
      this.pageHeight = scollH + "px";
    }

    this.renderResize();
    this.setShowLoad(false); //加载状态，默认为true加载
    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      this.renderResize,
      false
    );
    this.iphonexType = isIphonex();
    document.title = "东华大事记";
    this.countDown();
    
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener("resize", this.renderResize, false);
  },
  methods: {
    ...mapMutations(["setShowLoad"]),

    renderResize() {
      // 判断横竖屏
      let scollW =
        document.documentElement.clientWidth || document.body.clientWidth; //视口大小
      let scollH =
        document.documentElement.clientHeight || document.body.offsetHeight; //视口大小
      if (window.orientation == 90 || window.orientation == -90) {
        //横屏
        this.landscape = true;
      } else {
        //竖屏
        this.landscape = false;
        if (scollW > scollH) {
          this.pageWidth = scollH + "px";
          this.pageHeight = scollW + "px";
        } else {
          this.pageWidth = scollW + "px";
          this.pageHeight = scollH + "px";
        }
      }
      // 做页面适配
      // 注意：renderResize方法执行时虚拟dom尚未渲染挂载，如果要操作vue实例，最好在this.$nextTick()里进行。
    },

    // onChange(index) {
    //   this.currentIndex = String(index);
    // },
    countDown() {
      let _this = this;
      if (parseInt(_this.countDownTime) < 5) {
        setTimeout(function () {
          _this.countDownTime++;
          console.log(this.countDownTime);
          _this.countDownText =
            _this.countDownTime + _this.countDownTime + "0%";
          _this.countDown();
        }, 1000);
      } else {
        _this.countDownShow = false;
      }
    },
    actionPage() {
      let _this = this;
      _this.kpShow = true;
      setTimeout(function () {
        _this.closeKpAmation();
      }, 1000);
    },
    closeKpAmation() {
      this.kpShow = false;
      this.pageShow = true;
    },
    getShare() {
      let _this = this;
      let url = window.location.href;
      _this.$api.userCenter.Wechat.getShare({
        url: url,
      })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            //配置参数
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名，见附录1
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline",
              ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            /**
             * 通过ready接口处理成功验证
             * config信息验证成功后会执行ready方法
             * 需在用户可能点击分享按钮前就先调用
             */
            wx.ready(function () {
              console.log("调用成功");
              let shareData = {
                title: "东华大事记",
                desc: "以东华之名，点亮生态之约", //这里请特别注意是要去除html
                link: url,
                imgUrl: "https://www.ahdhst.com/images/home/newLogo.png",
              };
              // console.log(shareData);

              //兼容新老版本接口， 如不需要处理逻辑情况下， 调试好可以直接使用
              if (wx.onMenuShareAppMessage) {
                //微信文档中提到这两个接口即将弃用，故判断
                wx.onMenuShareAppMessage(shareData); //1.0 分享到朋友
                wx.onMenuShareTimeline(shareData); //1.0分享到朋友圈
              } else {
                wx.updateAppMessageShareData(shareData); //1.4 分享到朋友
                wx.updateTimelineShareData(shareData); //1.4分享到朋友圈
              }
            });

            wx.error((res) => {
              //通过error接口处理失败验证
              // config信息验证失败会执行error函数
              console.log(JSON.stringify(res));
            });
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(JSON.stringify(err));
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
    scrollerHeight: function () {
      return this.pageHeight;
    },
    scrollerWeight: function () {
      return this.pageWidth;
    },
  },
};
</script>
<style lang="less">
.dhsharePage {
  width: 100%;
  height: 100%;
  font-family: "PingFangSC-Regular", "PingFang SC";
  .spAmation {
    width: 100%;
    height: 100%;
    background: url("../../../../public/img/dhShare/syGif.gif");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    .textAmationed {
      width: 100%;
      height: 100%;
      background: url("../../../../public/img/dhShare/textGif.gif");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      position: relative;
      .logo {
        position: absolute;
        top: 15px;
        left: 16px;
        width: 60px;
        height: 43px;
        img {
          max-width: 100%;
        }
      }
      .circleBox {
        .countDown {
          position: absolute;
          bottom: 40px;
          left: 50%;
          margin-left: -30px;
          .van-circle__text {
            color: #6bc3a5;
            font-size: 14px;
            font-weight: 600;
          }
        }
        .kpBtn {
          width: 100%;
          text-align: center;
          font-weight: 600;
          color: #6bc3a5;
          font-size: 16px;
          position: absolute;
          bottom: 40px;
        }
      }
    }
  }
  .sectionPage {
    width: 100%;
    height: 100%;
    .slideBox {
      width: 100%;
      height: 100%;
      position: relative;
      .leftIcon {
        width: 28px;
        height: 20px;
        animation: textLeftAmation 2s infinite linear;
        position: absolute;
        top: 15px;
        left: 50%;
        margin-left: -18px;
        z-index: 999;
        img {
          max-width: 100%;
        }
        img:last-child {
          position: absolute;
          top: -10px;
          left: 0;
        }
      }
      .rightIcon {
        width: 28px;
        height: 20px;
        animation: textRightAmation 2s infinite linear;
        position: absolute;
        bottom: 15px;
        left: 50%;
        margin-left: -18px;
        z-index: 999;
        img {
          max-width: 100%;
        }
        img:last-child {
          position: absolute;
          top: -10px;
          left: 0;
        }
      }
    }
  }
  // .rotatePage {
  //   transform: rotate(90deg);

  //   -ms-transform: rotate(90deg); /* IE 9 */

  //   -moz-transform: rotate(90deg); /* Firefox */

  //   -webkit-transform: rotate(90deg); /* Safari and Chrome */

  //   -o-transform: rotate(90deg); /* Opera */
  // }
  .van-overlay {
    background-color: rgba(0, 0, 0, 0.9);
  }
  .wapPopup {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    .wapMain {
      position: absolute;
      width: 100%;
      top: 50%;
      margin-top: -40px;
      text-align: center;
      .zhuan {
        position: relative;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: inline-block;
        width: 80px;
        border: none;
        vertical-align: middle;
        pointer-events: none;
      }
      p {
        margin-top: 10px;
        // text-align: center;
        color: #fff;
        font-size: 8px;
      }
    }
  }
}
</style>